<template>
    <section class="no-result">
        <span>{{text}}</span>
    </section>
</template>

<script>
    export default {
        components: {},
        props: {
            text: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                
            }
        },
        methods: {
           
        },
        created(){
		}
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
